import { render, staticRenderFns } from "./AddTenancyContractTab.vue?vue&type=template&id=56a939e5&scoped=true"
import script from "./AddTenancyContractTab.vue?vue&type=script&lang=js"
export * from "./AddTenancyContractTab.vue?vue&type=script&lang=js"
import style0 from "./AddTenancyContractTab.vue?vue&type=style&index=0&id=56a939e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a939e5",
  null
  
)

export default component.exports